export var storiesLayers = [{
  id: 'Stories',
  type: 'storyStateChange',
  action: 'stateChange',
  name: 'story',
  model: 'story',
  event: true,
  modelize: function modelize(_ref) {
    var id = _ref.id,
      action = _ref.action;
    return {
      id: "story-".concat(id),
      action: action
    };
  }
}];